import { Common, color, Widget } from '@stockbit/ui';
import styled from 'styled-components';

const { Text } = Common;

export const Td = styled(Text).attrs({
  height: '30px',
  padding: '0 10px',
  size: '12.5px',
})`
  cursor: pointer;
  border-bottom: 1px solid ${color.gainsboro};
  display: block;
`;

export const Th = styled(Td).attrs({
  family: 'bold',
  size: '11.5px',
})`
  border-bottom: none;
`;

const button = `
  border-radius: 0px;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;

  .anticon {
    display: none;
  }
`;

export const TableContainer = styled.div`
  height: calc(100% - 40px);
  overflow-y: auto;

  .ant-table-wrapper {
    .ant-pagination {
      display: none;
    }
  }
  
  .ant-pagination {
    margin: 10px;
  }

  .ant-pagination-item, 
  .ant-pagination-jump-next, 
  .ant-pagination-jump-prev {
    display: none;
  }
  .ant-pagination-next {
    button {
      ${button}

      &:before {
        content: 'Next';
        font-family: var(--regular-font);
      }
    }
  }
  .ant-pagination-prev {
    margin-right: 0;
    button {
      border-right: none;
      ${button}

      &:before {
        content: 'Prev';
        font-family: var(--regular-font);
      }
    }
  }

  .ant-pagination-next:not(.ant-pagination-disabled),
  .ant-pagination-prev:not(.ant-pagination-disabled) {
    button {
      color: ${color.primary};

      &:hover {
        border-color: ${color.gainsboro};
        color: ${color.primary};
      }
    }
  }
`;